module.exports = __webpack_public_path__ + "static/media/favicon.5baec312.ico";